import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import { clearString } from "../../../utils/functions";
import api from "../../../settings/api";

export interface Fetch {
  phone?: string;
  email?: string;
  channelType?: "whatsapp" | "sms" | "email";
  name?: string;
  plate: string;
  callback: (success: boolean, errorMessage?: string) => void;
}

export interface SendPinAvulsoAction {
  type: string;
  payload: Fetch;
}

export default function* sendPinAvulso({
  payload,
}: SendPinAvulsoAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const data: {
      licensePlate: string;
      cellphone: string;
      email: string;
      sourceTypeCRM: string;
      journey: string;
      channelCRM: string;
    } = {
      licensePlate: clearString(payload.plate).toUpperCase(),
      cellphone: payload.phone ? clearString(payload.phone) : "",
      email: payload.email || "",
      sourceTypeCRM: "FREE_FLOW/FREEFLOW_VALIDACAO",
      journey: "TRS_INF_ATT_PAG_TOK_WPPU_01",
      channelCRM: payload.channelType || "sms",
    };

    const response = yield call(api.post, `/v1/customers/pins`, data);

    if (
      response?.data?.status?.codigoRetorno === 0 ||
      response?.status === 200
    ) {
      yield call(payload.callback, true);
    } else {
      yield call(payload.callback, false, "error");
    }
  } catch (error) {
    yield call(payload.callback, false, "timeout");
  }
}
